import React from 'react';

import logo from './assets/images/logo.png';

export const LogoImage = () => (
  <img
    src={logo}
    alt="Who Wants To Be A Millionaire"
    className="cover-image"
  />
);
